import { isRef, unref, watchEffect } from 'vue'
import type { MaybeRef } from '@vueuse/core'
import { format } from 'date-fns'

export function useWatchQueryParam(
  paramName: string,
  queryValue: MaybeRef<undefined | Date | string | number | null>,
) {
  if (isRef(queryValue)) {
    watchEffect(() => {
      const url = new URL(window.location.href)
      let value = unref(queryValue)
      if (value instanceof Date) {
        value = format(value, 'yyyy-MM-dd')
      } else if (typeof value === 'number') {
        value = String(value)
      }

      if (value) {
        url.searchParams.set(paramName, value)
      } else {
        url.searchParams.delete(paramName)
      }
      window.history.replaceState(history.state, '', url)
    })
  }
}
